/* eslint-disable react/prop-types */
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import { Box } from "@mui/material";
import React from "react";
import Modal from "../common/Modal/Modal";
import Typography from "../common/new/Typography/Typography";

const Styles = {
  alignComponent: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  alignMessage: {
    width: 450,
    display: "flex",
    textAlign: "center",
    flexWrap: "wrap",
  },
};

function SuccessfullyBookedModal({ open, onClose, email, position }) {
  return (
    <div>
      <Modal open={open}>
        <Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <CloseIcon
              sx={{
                color: "#A4A4A4",
                cursor: "pointer",
                stroke: "#A4A4A4",
                strokeWidth: 1,
              }}
              onClick={onClose}
            />
          </Box>
          <Box mt={-5} style={Styles.alignComponent}>
            <CheckCircleIcon
              sx={{
                color: "#6ADD72",
                fontSize: "68px",
              }}
            />
          </Box>
          <Box mt={3} style={Styles.alignComponent}>
            <Typography variant="title2" color="#043D90">
              Congratulation
            </Typography>
          </Box>
          <Box mt={3} style={Styles.alignComponent}>
            <Typography fontSize="16px" color="#8C8C8C">
              This member is appointed as a {position}.
            </Typography>
          </Box>
          <Box mt={5} style={Styles.alignMessage}>
            <Typography fontSize="16px" color="#8C8C8C">
              Login credential has been sent to your email {email}.
            </Typography>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
export default SuccessfullyBookedModal;
